import { IllustrationStyleDictionary } from 'services/graphql/fragments/IllustrationStyleDictionary';
import {
  VxlListItemFragment,
  VxlSectionDividerFragment,
} from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const MoveMoneyPageTileQuery = gql`
  query MoveMoneyPageTile($input: MoveMoneyPageTileInput!) {
    moveMoneyPageTile(input: $input) {
      id
      tiles {
        ... on MoveMoneyPageSectionTile {
          id
          status
          tileType
          __typename
          header {
            id
            tileType
            status
            __typename
            ... on ProductOfferSingleCardTile {
              card {
                __typename
                id
                titleText
                bodyText
                actionTextV2
                illustration {
                  ...IllustrationStyleDictionary
                }
                onClickV2 {
                  ... on RouteNavigationAction {
                    route
                    __typename
                  }
                }
                illustrationKey
                imageBackgroundColor
              }
            }
            ... on MoveMoneyVxlTile {
              id
              tileType
              status
              content {
                ...VxlListItemFragment
                ...VxlSectionDividerFragment
                __typename
              }
            }
          }
          tiles {
            ... on MoveMoneyVxlTile {
              id
              status
              tileType
              content {
                ...VxlListItemFragment
                ...VxlSectionDividerFragment
              }
            }
          }
        }
      }
    }
  }
  ${VxlListItemFragment}
  ${VxlSectionDividerFragment}
  ${IllustrationStyleDictionary}
`;

export default MoveMoneyPageTileQuery;
